import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const getRefFromUrl = () => {
  if (typeof window === "undefined") return null;
  const p = new URLSearchParams(window.location.search);
  return p.get("ref");
};

export const joinWaitlist = async (email, source = "landing") => {
  const referrer = typeof document !== "undefined" ? document.referrer || null : null;
  const ref = getRefFromUrl();
  const res = await axios.post(`${API}/waitlist`, { email, source, referrer, ref });
  return res.data;
};

export const getWaitlistCount = async () => {
  const res = await axios.get(`${API}/waitlist/count`);
  return res.data;
};

export const trackPageview = (path) => {
  if (typeof navigator !== "undefined" && /ReactSnap/i.test(navigator.userAgent)) return;
  const referrer = typeof document !== "undefined" ? document.referrer || null : null;
  axios.post(`${API}/track`, { path, referrer }).catch(() => {});
};

export const getStats = async () => {
  const res = await axios.get(`${API}/stats`);
  return res.data;
};

export const generateReport = async (location, industry) => {
  const res = await axios.post(`${API}/report/generate`, { location, industry });
  return res.data;
};
